module.exports = __webpack_public_path__ + "static/media/bg9.3d90e107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg9.jpg
// module id = 591
// module chunks = 0